import { render } from "./ProductsListComponent.vue?vue&type=template&id=4d3f2a2c&scoped=true"
import script from "./ProductsListComponent.vue?vue&type=script&lang=js"
export * from "./ProductsListComponent.vue?vue&type=script&lang=js"

import "./ProductsListComponent.vue?vue&type=style&index=0&id=4d3f2a2c&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3f2a2c"]])

export default __exports__